import { VOBlogKind, VOExpeditionPhase, VORoutePhase } from "../model/DataStructure.js";
import { Sensor, SensorEntry } from "../model/Sensor.js";
import { Path } from "../utils/Path.js";

export class Route {
    public point: SensorEntry = null;

    private _group: SVGGElement
    // private _path: SVGPathElement;
    // private _pathRest: SVGPathElement;
    private _date: Date = new Date();
    private _scale: number = 1;
    private _visible: boolean = true;
    private _active: boolean = true;

    constructor(private _sensor: Sensor) {
        // var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        // path.classList.add("full", "route-path");
        // path.setAttribute("data-kind", this.kind);
        // path.setAttribute("fill", "transparent");
        // this._path = path;

        // var rest = document.createElementNS("http://www.w3.org/2000/svg", "path");
        // rest.classList.add("rest", "route-path");
        // rest.setAttribute("data-kind", this.kind);
        // rest.setAttribute("fill", "transparent");
        // this._pathRest = rest;

        this._group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        this._group.classList.add("route-path-container");
        // this._group.appendChild(this._pathRest);
        // this._group.appendChild(this._path);

        _sensor.onChange.add(() => this.setDate(this._date));
    }

    public get kind(): VOBlogKind {
        return this._sensor ? this._sensor.kind : "mosaic";
    }

    public addTo(svg: SVGElement): void {
        // svg.appendChild(this._pathRest);
        // svg.appendChild(this._path);
        svg.appendChild(this._group);
    }

    public setScale(scale: number): void {
        if (this._scale === scale)
            return;
        this._scale = scale;

        //Polyfill for css: vector-effect: non-scaling-stroke
        // if (e5.Caps.isEdge || e5.Caps.isInternetExplorer) {
        // }
        var strokeWidth = (3 * (0.75 / scale)).toFixed(2) + "";
        // this._path.style.strokeWidth = strokeWidth;
        // this._pathRest.style.strokeWidth = strokeWidth;
        this._group.style.strokeWidth = strokeWidth;
    }

    public setDate(date: Date): SensorEntry {
        this._date = new Date(date);
        var pt = this._sensor.getEntry(date, "nearest");
        this.setRoutePoint(pt);
        return pt;
    }

    private setRoutePoint(pt: SensorEntry): void {
        if (!pt)
            return;

        this.point = pt;

        // var isCreated = !!pt.pathData;
        // if (!isCreated)
        //     console.time("Route.setRoutePoint()");

        pt.pathData = pt.pathData || this.getPath(0, pt.index + 1, "full");
        pt.pathDataRest = pt.pathDataRest || this.getPath(pt.index, this._sensor.entries.length, "rest");

        this._group.innerHTML = "";
        for (var path of pt.pathDataRest) {
            this._group.appendChild(path);
        }
        for (var path of pt.pathData) {
            this._group.appendChild(path);
        }

        // this._path.setAttribute("d", pt.pathData);
        // this._pathRest.setAttribute("d", pt.pathDataRest);

        // if (!isCreated)
        //     console.timeEnd("Route.setRoutePoint()");
    }

    private getPath(start: number, end: number, cssClass: string = ""): SVGPathElement[] {
        var fill = this._sensor.entries.slice(start, end);

        //For Nansen, we do not split the route into segments/phases.
        if (this.kind === "nansen") {
            var simply = Path.simplify(fill);
            return [this.createPath(Path.toSvgPathData(simply), cssClass)];
        }

        var result: SVGPathElement[] = [];
        var points: SensorEntry[] = [];
        var current: VORoutePhase = null;

        for (var sensorEntry of fill) {

            if (sensorEntry.phase != current) {
                if (points.length > 1) {
                    points.push(sensorEntry);
                    var simply = Path.simplify(points);
                    result.push(this.createPath(Path.toSvgPathData(simply), cssClass, current));
                    points = [];
                }
                current = sensorEntry.phase;
            }

            points.push(sensorEntry);
        }

        if (points.length > 1) {
            points.push(sensorEntry);
            var simply = Path.simplify(points);
            result.push(this.createPath(Path.toSvgPathData(simply), cssClass, current));
        }

        return result;
    }

    private createPath(d: string, cssClass: string = "", phase: VORoutePhase = null): SVGPathElement {
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.classList.add("route-path");
        if (cssClass) {
            path.classList.add(cssClass);
        }
        path.setAttribute("data-kind", this.kind);
        if (phase) {
            path.setAttribute("data-phase", phase);
        }
        path.setAttribute("fill", "transparent");
        path.setAttribute("d", d);
        return path;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(active: boolean) {
        if (this._active == active) {
            return;
        }
        this._active = active;

        // this._path.classList.toggle("deactive", !active);
        // this._pathRest.classList.toggle("deactive", !active);
        this._group.classList.toggle("deactive", !active);
    }

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(visible: boolean) {
        if (this._visible == visible) {
            return;
        }
        this._visible = visible;

        // this._path.classList.toggle("hidden", !visible);
        // this._pathRest.classList.toggle("hidden", !visible);
        this._group.classList.toggle("hidden", !visible);
    }
}